'use strict';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUpdatedFilterState } from '../cfs-hub-slice';

let TaxonomyFilter = ({ filterItems, navigatedItem, filterName, label }) => {
	const dispatch = useDispatch();

	const locationInvalid = useSelector(state => state.cfsHubSearch.location.invalid);

	const [selectedValue, setSelectedValue] = useState('');

	useEffect(() => {
		if (locationInvalid) {
			setSelectedValue('');
		}
	}, [locationInvalid]);

	const onItemSelected = (e) => {
		if (locationInvalid) {
			setSelectedValue('');
		} else {
			setSelectedValue(e.target.value);

			dispatch(fetchUpdatedFilterState({
				name: filterName,
				value: e.target.value
			}));
		}
	};

	const onItemDeselected = () => {
		setSelectedValue('');

		dispatch(fetchUpdatedFilterState({
			name: filterName,
			value: ''
		}));
	};

	const defaultValue = '';
	const options = filterItems.map((item) => (
		<option key={item.value} value={item.value}>
			{item.value}
		</option>
	));

	const renderSelected = () => {
		return (
			<div>
				<span className="cfs-hub-filters__filter cfs-hub-filters__filter--selected">
					<label>{label}</label>
					<span className="cfs-hub-filters__filter__value cfs-hub-filters__filter__value--selected">
						<button
							className="cfs-hub-filters__filter__remove fi-icon fi-icon--large fi-icon--no-margin fi-x-circle"
							onClick={onItemDeselected} />
						<span className="search-filters__filter__value__text">{navigatedItem.displayText}</span>
					</span>
				</span>
			</div>
		);
	};

	const renderUnselected = () => {
		return (
			<div className="cfs-hub-filters__taxonomy">
				<div className="cfs-hub-filters__filter">
					<label>{label}</label>
					<select className="cfs-hub-filters__filter__value" onChange={onItemSelected} value={selectedValue} >
						<option key={defaultValue} value={defaultValue}>Any {label.toLowerCase()}</option>
						{options}
					</select>
				</div>
			</div>
		);
	};

	if (navigatedItem) {
		return renderSelected();
	} else {
		return renderUnselected();
	}
}

TaxonomyFilter = React.memo(TaxonomyFilter);

export { TaxonomyFilter };